/**
 * Typed wrappers around `react-redux`'s `useDispatch` and `useSelector`.
 *
 * All application code MUST import `useAppDispatch` / `useAppSelector` from
 * this file rather than calling the raw hooks directly. The `no-restricted-imports`
 * rule in each app's ESLint config enforces this convention.
 */
// eslint-disable-next-line no-restricted-imports -- this file is the canonical wrapper
import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from '@dfq/shared/stores/index';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();

export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector<RootState, T>(selector);
